// page/auth/admin/modals/DepartmentDeleteModal.jsx
import React, { useEffect, useMemo, useState } from "react";
import { api } from "../../../../util/api";
import { Stack, Typography, Divider } from "@mui/material";
import { notify } from "../../../../util/toast";
import { runApiAction } from "../../../../util/apiFeedback";
import { API } from "../api/endpoints";
import FormModal from "../../../../component/common/FormModal";
import ComboBox from "../../../../component/common/ComboBox";

export default function DepartmentDeleteModal({ open, onClose, target, departments, onDeleted }) {
    const deptList = useMemo(() => (Array.isArray(departments) ? departments : []), [departments]);
    const [moveToDeptId, setMoveToDeptId] = useState("");

    useEffect(() => {
        if (!open) return;
        const first = deptList.find((d) => d.deptId !== target?.deptId);
        setMoveToDeptId(first ? first.deptId : "");
    }, [open, target, deptList]);

    const canMoveTargets = useMemo(() => deptList.filter((d) => d.deptId !== target?.deptId), [deptList, target]);

    const handleDelete = () => {
        if (!target?.deptId) return;
        if (!moveToDeptId) return notify("직원 이동할 부서를 선택하세요.", "warning");

        return runApiAction({
            request: () => api.post(API.departments.delete(target.deptId), {
                moveToDeptId: Number(moveToDeptId),
            }),
            successMsg: "부서가 삭제되었습니다. 직원들은 선택한 부서로 이동되었습니다.",
            onSuccess: () => onDeleted?.(),
        });
    };

    return (
        <FormModal
            open={open}
            onClose={onClose}
            title="부서 삭제"
            subtitle={target ? `삭제 대상: ${target.deptName} (ID: ${target.deptId})` : undefined}
            maxWidth="sm"
            onSave={handleDelete}
            saveLabel="삭제 실행"
            saveColor="danger"
            saveDisabled={canMoveTargets.length === 0}
        >
            <Stack spacing={1.25}>
                <Typography sx={{ fontSize: 13, fontWeight: 800, color: "text.secondary" }}>
                    ✅ 이 부서에 소속된 직원들이 존재할 수 있습니다.
                    삭제 전, 직원들이 이동할 부서를 선택해야 합니다.
                </Typography>

                <Divider />

                <ComboBox
                    clearable={false}
                    placeholder="직원 이동 부서"
                    options={canMoveTargets.map((d) => ({
                        value: d.deptId,
                        label: `${d.deptName} (ID: ${d.deptId})`,
                    }))}
                    value={moveToDeptId}
                    onChange={(v) => setMoveToDeptId(v)}
                />

                {canMoveTargets.length === 0 && (
                    <Typography sx={{ fontSize: 13, color: "error.main", fontWeight: 700 }}>
                        이동할 부서가 없습니다. (삭제 대상 외 부서를 먼저 생성하세요)
                    </Typography>
                )}
            </Stack>
        </FormModal>
    );
}
